import React from 'react';
import { useSelector } from 'react-redux';

import {
  areAppliedFiltersPresentSelector,
  selectedBulkUpdateSbatGroupsSelector,
} from 'features/classCreation';
import AddSuperBatchesButton from '../AddSuperBatchesButton';
import DeleteSbatGroupButton from '../DeleteSbatGroupsButton';
import RemoveSuperBatchesButton from '../RemoveSuperBatchesButton';
import styles from './BulkActions.module.scss';
import UpdateInstructorButton from '../UpdateInstructorButton';

function BulkActions() {
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);
  const selectedSbatGroupsCount = Object.keys(selectedSbatGroups).length;
  const areAppliedFiltersPresent = useSelector(
    areAppliedFiltersPresentSelector
  );
  const areBulkActionsActive = selectedSbatGroupsCount > 0;

  if (areBulkActionsActive || areAppliedFiltersPresent) {
    return (
      <>
        <div className="h5 bold m-t-xxs">
          {`(${selectedSbatGroupsCount}) Items selected`}
        </div>
        <div className={styles.hintText}>
          The below actions will be applied to the above selected items
        </div>
        <AddSuperBatchesButton disabled={!areBulkActionsActive} />
        <RemoveSuperBatchesButton disabled={!areBulkActionsActive} />
        <UpdateInstructorButton disabled={!areBulkActionsActive} />
        <DeleteSbatGroupButton disabled={!areBulkActionsActive} />
      </>
    );
  } else {
    return (
      <div className="disabled h6 m-t-xxs">
        Bulk actions will be displayed when classes are selected.
      </div>
    );
  }
}

export default BulkActions;
